import React from "react";
import "./Testimonials.css";
import { FaQuoteLeft } from "react-icons/fa";

const testimonials = [
  {
    name: "Dr. Patrick Carone MD, CSCS, MBA",
    quotes: [
      "As a physician and strength coach, I've worked with a lot of rehab professionals over the years. Dr. Blaine Harteis is one of the best I've come across. After tearing my right rotator cuff in November 2024 and having a very successful surgery, I was referred specifically to Blaine because of his expertise with sports injuries and shoulder rehab.",
      "From day one, he built a program that factored in my body building background and current training style. We didn't follow a generic protocol, he made sure every step of the rehab process was tailored to get me back under the weights as safely and efficiently as possible. My range of motion and strength returned quickly, post-op pain resolved sooner than expected, and I was able to get back to training at full capacity without pain.",
      "Blaine brings a smart, focused approach that actually fits the way athletes train and recover. That made a huge difference in my recovery. If you're serious about getting back to doing what you love, I can't recommend him enough! Check out his new practice at Harteis Physical Therapy & Sports Performance.",
    ],
  },
  {
    name: "Max Kallock, Division II Baseball Player",
    quotes: [
      "After years of misdiagnoses and living with severe pain, I was referred to Blaine following a rare spine surgery with one goal — to return to playing baseball at a high level. From day one, Blaine was thorough and deeply engaged in every assessment. He even took the time to research my rare procedure and dedicated as much one-on-one attention as I needed.",
      "To get back on the field, I had to rebuild my strength, regain flexibility, and restore my confidence. Blaine went above and beyond every step of the way. Not only is he an exceptional physical therapist, but he's also become a great friend. I never thought I'd recover the strength I once had — but thanks to Blaine, I did.",
    ],
  },
  {
    name: "Mary Lopez",
    quotes: [
      "For years, I put off having a knee replacement, convinced that wearing a brace gave me enough support and freedom. I had seen others go through knee replacement surgery and therapy without much improvement in their quality of life — so I wasn't in a hurry.",
      "It didn't take long for me to realize that the therapist makes all the difference. Blaine created a program tailored to my needs, starting with my goals and designing therapy around them. Each week, as I progressed, he adjusted and challenged me to keep improving.",
      "Blaine became more than just my therapist — he became a friend who pushed me to achieve more than I thought possible. Today, I'm back at work and back to my passion for trail riding. I'm moving better than I have in years. If you follow his program and advice, you can trust he'll help you reach your goals too.",
    ],
  },
  {
    name: "Bethany Bachman",
    quotes: [
      "After tearing my ACL and meniscus playing volleyball in 2023 and spending nearly a full year in traditional PT, I still didn't feel fully confident in my recovery. As an athlete, it was very important to me that I could somehow get back to living the same active lifestyle I had pre-injury, which pushed me to try a different approach. At my first consult appointment with Blaine in April 2025, after his assessment of my status, he reassured me that we could reach a full recovery with quad strengthening and agility training.",
      "Over the next 4 months, he went on to push me past limits I didn't know I had set for myself. His strategic, measured approach has definitely built my strength, completely eliminating any pain I had remaining, and most importantly, restored my confidence which I know will drive my outcome. Blaine definitely understands the mental and physical sides of recovery and knows exactly how to challenge and encourage his clients.",
    ],
  },
];

export default function Testimonials() {
  return (
    <main className="Testimonials">
      <p className="section-eyebrow">Client Stories</p>
      <h1>Testimonials</h1>
      <hr />
      <div className="testimonial-grid">
        {testimonials.map((t) => (
          <div className="card t" key={t.name}>
            <FaQuoteLeft className="quote-icon" size={26} />
            <h2 className="title">{t.name}</h2>
            {t.quotes.map((q, i) => (
              <p key={i}>{q}</p>
            ))}
          </div>
        ))}
      </div>
    </main>
  );
}
